export { Card, Cards } from "fumadocs-ui/components/card";
